export default __webpack_public_path__ + "static/media/logo_lareina.df6a5031.png";